import {FC, useState} from 'react';
import {Box, Icon, Typography} from '@mui/material';
import {ReactComponent as SecurityIcon} from '@icons/security-safe.svg';
import Input from '@/shared/components/Inputs/Input';
import {twoStepAuthenticationStyles} from './TwoStepAuthentication.styles';
import Button from '@/shared/components/Button';
import {OUTLINE} from '@/utils/constants';
import {SuperAdminService} from '@/utils/services';
import {getErrorMessage} from '@/utils/helpers';
import {toast} from 'react-toastify';
import {ITwoFactorSetupResponse} from '@/utils/types/superAdmin.interface';

interface TwoStepAuthenticationModalStep2Props {
  onClose: () => void;
  onSetupDone: (prop: ITwoFactorSetupResponse) => void;
}

const PasswordStep: FC<TwoStepAuthenticationModalStep2Props> = ({onClose, onSetupDone}) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonContinueClick = async () => {
    if (!password) return setError('Password is required');
    setIsLoading(true);
    try {
      const {data} = await SuperAdminService.setAdmin2FactorSetup({password});

      onSetupDone(data);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <Icon sx={twoStepAuthenticationStyles.icon}>
        <SecurityIcon />
      </Icon>
      <Typography sx={twoStepAuthenticationStyles.mainTitle}>Enter your password</Typography>
      <Typography sx={twoStepAuthenticationStyles.mainDescription}>
        For security reasons, please enter your password to continue.
      </Typography>
      <Box>
        <Input placeholder="Enter your password" label="Password" onChange={setPassword} errorMessage={error} type="password" />
      </Box>
      <Box sx={twoStepAuthenticationStyles.buttonWrapper}>
        <Button title="Cancel" variant={OUTLINE} onClick={onClose} />
        <Button title="Continue" onClick={handleButtonContinueClick} disabled={isLoading || !password.trim()} />
      </Box>
    </Box>
  );
};

export default PasswordStep;
